import { Text, useColorModeValue } from "@chakra-ui/react";

export const AboutMe = () => {
  const mutedColor = useColorModeValue("gray.600", "gray.400");
  return (
    <Text fontSize={{ base: "md", md: "lg" }} color={mutedColor} lineHeight="1.7">
      I am a software engineer based in Amsterdam, the Netherlands. I work with Java, Spring Boot,
      and React — from APIs and services to full-stack products.
    </Text>
  );
};
